//(function () {
//	'use strict';

//    const module = angular.module('imApp');

//    module.component('activityTypes', {
//        templateUrl: 'views/components/views/activityTypes/activityTypes.template.html?v=' + module.version,
//		controllerAs: 'vm',
//        controller: ['stateService', 'activityTypesService', function (stateService, activityTypesService) {

//            // #region VARIABLES & DEFINITIONS

//            const vm = this;

//            vm.model = {
//                itemsListActivityTypes: []
//            };

//            // #endregion VARIABLES & DEFINITIONS

//            // #region LOAD PROCEDURE FUNCTION CALL

//            async function loadActivityTypes() {
//                vm.model.itemsListActivityTypes = await activityTypesService.listActivityTypes({ onweb: 'ALL' });
//            }

//            // #endregion LOAD PROCEDURE FUNCTION CALL

//            // #region MULTI DIRECTION BUTTON FUNCTIONS

//            vm.goToFunc = function (state, e) {
//                function go(parms) {
//                    if (e?.ctrlKey) {
//                        stateService.newTab(state, parms);
//                    } else {
//                        stateService.go(state, parms);
//                    }
//                }

//                switch (state) {
//                    case 'activitytype':
//                        go({ activitytype_no: '0' });
//                        break;
//                    default:
//                        break;
//                }
//            };

//            // #endregion MULTI DIRECTION BUTTON FUNCTIONS

//            // #region ON INIT FUNCTION

//            vm.$onInit = function () {
//                loadActivityTypes();
//            }

//            // #endregion ON INIT FUNCTION

//		}]
//	});
//})();
